// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

// # Unprovisioned Homepage Card
// Children will typically be instance of './views/unprovisioned-info'

// ## Dependencies
import { Card } from '@salesforce/design-system-react';

// ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// A simple javascript utility for conditionally joining classNames together.
import classNames from 'classnames';

// ### React
import React from 'react';
import PropTypes from 'prop-types';

function UnprovisionedCard(props) {
  const { children, className, heading, height, icon, ...rest } = props;

  return (
    <Card
      bodyClassName="slds-grow slds-grid"
      className={classNames('slds-card--narrow slds-grid slds-grid--vertical slds-p-bottom--large', className)}
      style={{ height }}
      heading={heading}
      icon={icon}
      {...rest}
    >
      <div className="slds-card__body--inner slds-grid slds-wrap slds-size--1-of-1 slds-grid--align-center slds-grid--vertical-align-center">
        {children}
      </div>
    </Card>
  );
}

// ### Display Name
UnprovisionedCard.displayName = 'HOMEPAGE_UNPROVISIONED_CARD';

// ### Prop Types
UnprovisionedCard.propTypes = {
  /**
   * The info section of the Unprovisoned Card
   */
  children: PropTypes.node,
  /**
   * CSS classes to be added to the design-system-react Card.
   */
  className: PropTypes.string,
  /**
   * The heading is the name of the related item group.
   */
  heading: PropTypes.string.isRequired,
  /**
   * Set height of the Homepage Card.
   */
  height: PropTypes.string,
  /**
   * Icon associated with the items within the `body`.
   */
  icon: PropTypes.node,
};

UnprovisionedCard.defaultProps = {
  height: '480px',
};

export default UnprovisionedCard;
